import React, { useState } from 'react';
import { GiBreadSlice, GiCheckMark, GiCircle, GiDrinking, GiForkKnifeSpoon, GiMeal } from 'react-icons/gi';
import './menusections.css';

// Función para capitalizar la primera letra de un texto
const capitalizeFirstLetter = (text) => {
  if (typeof text !== 'string') return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const MenuSection = ({ comidas, bebidas, complementos }) => {
  // Estado para gestionar las secciones abiertas
  const [openSections, setOpenSections] = useState([]);
  // Estado para gestionar los ítems seleccionados
  //const [selectedItems, setSelectedItems] = useState([]);

  // Función para alternar la visibilidad de las secciones del menú
  const handleToggleSection = () => {
    setOpenSections(prevOpenSections =>
      prevOpenSections.includes(0)
        ? prevOpenSections.filter(index => index !== 0) // Cerrar la sección si ya está abierta
        : [...prevOpenSections, 0] // Abrir la sección si no está abierta
    );
  };

  // ✅ Extraer bebidas y complementos de todas las comidas
  bebidas = comidas?.flatMap(comida => comida.bebidas || []) || [];
  complementos = comidas?.flatMap(comida => comida.complementos || []) || [];


  console.log("Datos recibidos: ", { comidas, bebidas, complementos });

  return (
    <div className="menu">
      <h3 className="menu-title promo">Menú</h3>

      {/* Sección principal 3 Tiempos */}
      <div className="type-list menu-section package">
        <h2 onClick={() => handleToggleSection(0)} className="section-title">
          <div className="with-sections">{comidas[0].tipoMenu}</div>
          <GiMeal className={`icon-menu ${openSections.includes(0) ? 'icon-expanded' : 'icon-collapsed'}`} />
        </h2>

        {/* Si la sección "3 Tiempos" está abierta, mostrar subsecciones */}
        {openSections.includes(0) && (
          <div className="section-content">
            
            {/* Sección de Comidas */}
            <div className="sub-section">
              {comidas && comidas.length > 0 ? (
                comidas.map((comida, idx) => (
                  <div key={idx}>
                    {/* Iterar sobre los tiempos y mostrar el 'tiempoMenu' */}
                    {comida.tiempos.map((tiempo, tiIdx) => (
                      <div key={tiIdx}>
                        <h3 className='promo-menu'>{tiempo.tiempoMenu}</h3> {/* Mostrar el 'tiempoMenu' aquí */}
                        <ul className="item-list">
                          {tiempo.platillos.map((platillo, platIdx) => (
                            <li key={platIdx} className="item">
                              <div>
                                <GiCircle className="item-icon-promo" />
                              </div>
                              <span className="item-promo">
                                {capitalizeFirstLetter(platillo)}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <p>No hay comidas disponibles.</p>
              )}
            </div>

          {/* 🔹 Sección de Bebidas: Solo se muestra si hay bebidas */}
          {bebidas && bebidas.length > 0 && (
            <div className="sub-section">
              <h3>Bebidas</h3>
              <ul className="item-list">
                {bebidas.map((bebida, idx) => (
                  <li key={idx} className="item">
                    <div>
                      <GiCircle className="item-icon-promo" />
                    </div>
                    <span className="item-promo">
                      {capitalizeFirstLetter(bebida)}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* 🔹 Sección de Complementos: Solo se muestra si hay complementos */}
          {complementos && complementos.length > 0 && (
            <div className="sub-section">
              <h3>Complementos</h3>
              <ul className="item-list">
                {complementos.map((complemento, idx) => (
                  <li key={idx} className="item">
                    <div>
                      <GiCircle className="item-icon-promo" />
                    </div>
                    <span className="item-promo">
                      {capitalizeFirstLetter(complemento)}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          </div>
        )}
      </div>
    </div>
  );
};


{/**  funcion para poder hacer la seleccion de items */}
  // // Función para manejar el cambio de selección de los ítems
  // const handleCheckboxChange = (item) => {
  //   setSelectedItems(prevSelectedItems =>
  //     prevSelectedItems.includes(item)
  //       ? prevSelectedItems.filter(selectedItem => selectedItem !== item) // Desmarcar
  //       : [...prevSelectedItems, item] // Marcar
  //   );
  // };

//   return (
//     <div className="menu">
//       <h3 className="menu-title promo">Menú</h3>

//       {/* Sección principal 3 Tiempos */}
//       <div className="type-list menu-section package">
//         <h2 onClick={handleToggleSection} className="section-title">
//           <div className="with-sections">{comidas[0].tipoMenu}</div>
//           <GiMeal className={`icon-menu ${openSections.includes(0) ? 'icon-expanded' : 'icon-collapsed'}`} />
//         </h2>

//         {/* Si la sección "3 Tiempos" está abierta, mostrar subsecciones */}
//         {openSections.includes(0) && (
//           <div className="section-content">
            
//             {/* Sección de Comidas */}
//             <div className="sub-section">
//                 {/* Cambié el título de "Comidas" para que se muestren los tiempos */}
//                 {comidas && comidas.length > 0 ? (
//                     comidas.map((comida, idx) => (
//                     <div key={idx}>
//                         {/* Iteramos sobre los tiempos de cada comida */}
//                         {comida.tiempos.map((tiempo, tiIdx) => (
//                         <div key={tiIdx}>
//                             <h3>{`${tiIdx + 1} tiempo`}</h3> {/* Aquí agregamos "1 tiempo", "2 tiempo", etc. */}
//                             <ul className="item-list"> {/* Agregamos clase "item-list" para el borde */}
//                             {/* Iteramos sobre los platillos de cada tiempo */}
//                             {tiempo.platillos.map((platillo, platIdx) => (
//                                 <li key={platIdx} className="item">
//                                 <input
//                                     type="checkbox"
//                                     checked={selectedItems.includes(platillo)} // Indicar si el ítem está seleccionado
//                                     onChange={() => handleCheckboxChange(platillo)} // Manejar el cambio de selección
//                                     id={`platillo-checkbox-${platIdx}`} // ID único para el checkbox
//                                     className="checkbox-input"
//                                 />
//                                 <label htmlFor={`platillo-checkbox-${platIdx}`} className="item-label">
//                                    {/*<FaCircle className="circle-icon" /> */} 
//                                     <span className={`item-text ${selectedItems.includes(platillo) ? 'selected' : ''}`}>
//                                     {capitalizeFirstLetter(platillo)} {/* Mostrar nombre del platillo */}
//                                     </span>
//                                 </label>
//                                 </li>
//                             ))}
//                             </ul>
//                         </div>
//                         ))} {/* Cierra el div de tiempos */}
//                     </div>
//                     ))
//                 ) : (
//                     <p>No hay comidas disponibles.</p>
//                 )}
//             </div>

//             {/* Sección de Bebidas */}
//             <div className="sub-section">
//               <h3>Bebidas</h3>
//               {bebidas && bebidas.length > 0 ? (
//                 <ul className="item-list"> {/* Agregamos clase "item-list" para el borde */}
//                   {bebidas.map((bebida, idx) => (
//                     <li key={idx} className="item">
//                       <input
//                         type="checkbox"
//                         checked={selectedItems.includes(bebida.nombre)} // Indicar si el ítem está seleccionado
//                         onChange={() => handleCheckboxChange(bebida.nombre)} // Manejar el cambio de selección
//                         id={`bebida-checkbox-${idx}`} // ID único para el checkbox
//                         className="checkbox-input"
//                       />
//                       <label htmlFor={`bebida-checkbox-${idx}`} className="item-label">
//                         {/*<FaCircle className="circle-icon" />*/}
//                         <span className={`item-text ${selectedItems.includes(bebida.nombre) ? 'selected' : ''}`}>
//                           {capitalizeFirstLetter(bebida.nombre)}
//                         </span>
//                       </label>
//                     </li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p>No hay bebidas disponibles.</p>
//               )}
//             </div>

//             {/* Sección de Complementos */}
//             <div className="sub-section">
//               <h3>Complementos</h3>
//               {complementos && complementos.length > 0 ? (
//                 <ul className="item-list"> {/* Agregamos clase "item-list" para el borde */}
//                   {complementos.map((complemento, idx) => (
//                     <li key={idx} className="item">
//                       <input
//                         type="checkbox"
//                         checked={selectedItems.includes(complemento.nombre)} // Indicar si el ítem está seleccionado
//                         onChange={() => handleCheckboxChange(complemento.nombre)} // Manejar el cambio de selección
//                         id={`complemento-checkbox-${idx}`} // ID único para el checkbox
//                         className="checkbox-input"
//                       />
//                       <label htmlFor={`complemento-checkbox-${idx}`} className="item-label">
//                         {/*<FaCircle className="circle-icon" />*/}
//                         <span className={`item-text ${selectedItems.includes(complemento.nombre) ? 'selected' : ''}`}>
//                           {capitalizeFirstLetter(complemento.nombre)}
//                         </span>
//                       </label>
//                     </li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p>No hay complementos disponibles.</p>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };